// Категорії/сфери салону — slug-и мають збігатися з бекендом
// (appointMe-server/services/categories.js). Людські назви — через i18n
// t(`discover.cat.${slug}`); емодзі — для карток/фільтрів.
export const CATEGORIES = [
  { slug: "nails", icon: "💅" },
  { slug: "hair", icon: "💇" },
  { slug: "barber", icon: "💈" },
  { slug: "brows_lashes", icon: "👁️" },
  { slug: "cosmetology", icon: "✨" },
  { slug: "makeup", icon: "💄" },
  { slug: "spa", icon: "🧖" },
  { slug: "waxing", icon: "🪮" },
  { slug: "tattoo", icon: "🎨" },
  { slug: "other", icon: "🌸" },
];

export const CATEGORY_ICON = Object.fromEntries(CATEGORIES.map((c) => [c.slug, c.icon]));
export const catLabel = (t, slug) => t(`discover.cat.${slug}`, slug);
